<template>
  <div>
    <!-- 无子级 -->
      <el-menu-item :index="item.LinkURL" v-if="!item.children">
        <i v-bind:class="item.inc"></i>
        <span slot="title">{{item.MenuName}}</span>
      </el-menu-item>
      <!-- 有子级 -->
      

      <el-submenu  :index="item.LinkURL+''" v-else>
        <template slot="title">
          <i v-bind:class="item.inc"></i>
          <span>{{item.MenuName}}</span>
        </template>

        <NavItem v-for="submenu in item.children" :key="submenu.url" :item="submenu" :path="submenu.LinkURL+''"/>
      </el-submenu>
  </div> 
</template>

<script>
export default {
  name:'NavItem',
  data(){
    return {
      items:[]
    }
  },
    methods: {
      gourl(url){
        this.$router.push(url);
      }
  },
  created() {
    // debugger
  },
  props:['item','path']  //父传子参数
}
</script>

<style>

</style>